module.exports = __webpack_public_path__ + "img/10.b8460829.png";